import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  FormControl,
  FormLabel,
  useToast,
  VStack,
  Text,
  Alert,
  AlertIcon,
} from '@chakra-ui/react';
import { validatePassword, getPasswordPromptMessage, getPasswordErrorMessage } from '../utils/passwordProtection';

const PasswordModal = ({ isOpen, onClose, onSuccess, title = "Password Required" }) => {
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const isValid = await validatePassword(password);
      
      if (isValid) {
        toast({
          title: "Access Granted",
          description: "Live transcription features are now enabled.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        
        onSuccess();
        onClose();
        setPassword('');
      } else {
        setError(getPasswordErrorMessage());
        setPassword('');
      }
    } catch (err) {
      console.error('Password validation error:', err);
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setPassword('');
    setError('');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <form onSubmit={handleSubmit}>
          <ModalHeader>{title}</ModalHeader>
          <ModalBody>
            <VStack spacing={4}>
              <Text fontSize="sm" color="gray.600">
                {getPasswordPromptMessage()}
              </Text>
              
              {error && (
                <Alert status="error" borderRadius="md">
                  <AlertIcon />
                  {error}
                </Alert>
              )}
              
              <FormControl isRequired>
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  autoFocus
                />
              </FormControl>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={handleClose}>
              Cancel
            </Button>
            <Button
              colorScheme="blue"
              type="submit"
              isLoading={isLoading}
              loadingText="Validating..."
            >
              Enable Features
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default PasswordModal;
